import React from 'react';
import styled from '../../styled';
import { Reveal } from '../motion';

const testimonials = [
  {
    logo: '/images/logos/usa-today.svg',
    alt: 'USA Today',
    quote:
      'The level of detail we can see now is a total game-changer. We\'re able to make smarter, faster decisions, and it\'s showing up in the revenue.',
    name: 'Jim Ryan',
    title: 'Sr Director of Affiliate Strategy, Commerce Content'
  },
  {
    logo: '/images/logos/people-inc.svg',
    alt: 'People Inc.',
    quote:
      "Affilimate's features and insights have been invaluable as we navigate the changing commerce landscape. And the incredible support is a cherry on top.",
    name: 'Jose Ramirez',
    title: 'SVP, Commerce Business Strategy'
  },
  {
    logo: '/images/logos/everyday-health-group.png',
    alt: 'Everyday Health Group',
    quote:
      "Affilimate delivers exceptional offsite tracking in a platform our teams actually use. It's deeply granular but simple to use, interpret, and drive material revenue from. Without tying up engineering resources.",
    name: 'Samantha Baker',
    title: 'Group VP, Everyday Health Group'
  }
];

const SectionWrapper = styled('section')`
  padding: 56px 24px 64px;
  max-width: 1200px;
  margin: 0 auto;
`;

const CardGrid = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  > * {
    height: 100%;
  }

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const Card = styled('article')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  box-sizing: border-box;
  padding: 24px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 4px 20px rgba(14, 28, 43, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: #bae7ff;
    box-shadow: 0 8px 28px rgba(24, 144, 255, 0.1);
  }
`;

const LogoImage = styled('img')`
  width: auto;
  height: 28px;
  max-width: 140px;
  object-fit: contain;
  object-position: left center;
`;

const Quote = styled('blockquote')`
  margin: 0;
  flex: 1;
  font-family: 'Merriweather', serif;
  font-size: 15px;
  line-height: 1.65;
  color: #0e1c2b;
  font-style: italic;
`;

const AuthorInfo = styled('div')`
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
`;

const AuthorName = styled('div')`
  font-size: 14px;
  font-weight: 700;
  color: #0e1c2b;
`;

const AuthorTitle = styled('div')`
  margin-top: 3px;
  font-size: 13px;
  line-height: 1.45;
  color: #64748b;
`;

export const TestimonialSection = () => {
  return (
    <SectionWrapper aria-label="Publisher testimonials">
      <CardGrid>
        {testimonials.map((item, index) => (
          <Reveal key={item.name} delay={index * 80}>
            <Card>
              <LogoImage src={item.logo} alt={item.alt} />
              <Quote>{item.quote}</Quote>
              <AuthorInfo>
                <AuthorName>{item.name}</AuthorName>
                <AuthorTitle>{item.title}</AuthorTitle>
              </AuthorInfo>
            </Card>
          </Reveal>
        ))}
      </CardGrid>
    </SectionWrapper>
  );
};
